import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { GetADTree } from '../../../actions/ActiveDocumentActions';
import useScreenSize from '../../../components/useScreenSize';

const ActiveDocumentSidebar = (props) => {
    const dispatch = useDispatch();
    const activeDocs = useSelector(state => state.activeDocumentsInfo.value);
    //const screenSize = useSelector(state => state.screenSizeInfo.value);
    const [adSettings, setADSettings] = useState(null);
    const [viewHeight, viewWidth] = useScreenSize();
    const [adTrees, setADTrees] = useState([]);
    const [favTrees, setFavTrees] = useState([]);
    const [showCompletedDocs, setShowCompletedDocs] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    //const [h, setH] = useState(window.innerHeight - 125);

    useEffect(() => {
        getADSettings();
        GetADTree(false, dispatch);
        console.log('search');
    },[]);



    useEffect(() => {

        setRefreshing(false);
        if(activeDocs.adTrees.length > 0 && adSettings !== null)
        {
            let adTree = [];
            let favTree = [];
            activeDocs.adTrees.forEach((tree) => {

                if(tree.type === 'ou')
                {
                    let newOUNode = {...tree};
                    if(adSettings.ouOpen.indexOf(tree.id) > -1) newOUNode.isOpen = true;

                    newOUNode.children = [];

                    tree.children.forEach((childTree) => {
                        let newBPNode = {...childTree};
                        if(adSettings.fav.indexOf(childTree.id) > -1) {
                            let favNode = {...newBPNode};
                            if(adSettings.favOpen.indexOf(newBPNode.id) > -1) favNode.isOpen = true;
                            newBPNode.isFav = true;
                            favTree.push(favNode);
                        }
                        if(adSettings.bpOpen.indexOf(childTree.id) > -1) newBPNode.isOpen = true;
                        newOUNode.children.push(newBPNode);

                    });
                    adTree.push(newOUNode);
                    // if(adSettings.fav.indexOf(newOUNode.id) > -1)
                    // {
                    //     console.log('pushFav');
                    //     let newFav = {...newOUNode};
                    //     newOUNode.isFav = true;
                    //     if(adSettigns.favOpen.indexOf(newFav.id) > -1) newFav.isOpen = true;
                    //     favTree.push(newFav);
                    // }

                }

                if(tree.type === 'bp')
                {
                    let newBPNode = {...tree};
                    if(adSettings.fav.indexOf(newBPNode.id) > -1) {
                        let favNode = {...newBPNode};
                        if(adSettings.favOpen.indexOf(newBPNode.id) > -1) favNode.isOpen = true;
                        favTree.push(favNode);
                        newBPNode.isFav = true;
                    }
                    if(adSettings.bpOpen.indexOf(tree.id) > -1) newBPNode.isOpen = true;
                    adTree.push(newBPNode);
                }
            });


            setADTrees(adTree);
            setFavTrees(favTree);

        }
    }, [activeDocs, adSettings]);

    const getADSettings = () => {
        var settings = null;
        try {
          settings = JSON.parse(localStorage.getItem('ADSettings'));
        } catch {}

        if (settings === null) {
          settings = {
            fav: [],
            favOpen: [],
            ouOpen: [],
            bpOpen: [],
          };
        }
        setADSettings(settings);


    }

    const updateADSettings = (type, action, id) => {
        var settings = null;
        try {
          settings = JSON.parse(localStorage.getItem('ADSettings'));
        } catch {}
        let arr = [];
        switch(type) {
            case 'fav':
                arr = [...settings.fav];
                break;
            case 'favOpen':
                arr = [...settings.favOpen];
                break;
            case 'ouOpen':
                arr = [...settings.ouOpen];
                break;
            case 'bpOpen':
                arr = [...settings.bpOpen];
                break;
        }
        if(action === 'add') {
            if(arr.indexOf(id) === -1) {
                arr.push(id);
            }
        } else {
            while(arr.indexOf(id) > -1)
            {
                let idx = arr.indexOf(id);
                arr.splice(idx, 1);
            }
        }
        let newSettings = {...settings};
        switch(type) {

            case 'fav':
                newSettings.fav = arr;
                break;
            case 'favOpen':
                newSettings.favOpen = arr;
                break;
            case 'ouOpen':
                newSettings.ouOpen = arr;
                break;
            case 'bpOpen':
                newSettings.bpOpen = arr;
                break;
        }
        setADSettings(newSettings);
        localStorage.setItem('ADSettings', JSON.stringify(newSettings));
    }

    const toggleNode = (node) => {
        if(node.type === 'bp') {
            props.LoadBPClick(node.id, showCompletedDocs);
        }
        let newTree = [...adTrees];
        let topNode = newTree.find((n) => n.id === node.id);
        let toggleOpenAction = 'add';
        if(node.isOpen) toggleOpenAction = 'remove';
        if(topNode) {
            if(topNode.type === 'ou') {
                updateADSettings('ouOpen', toggleOpenAction, node.id);
            } else {
                updateADSettings('bpOpen', toggleOpenAction, node.id);
            }
        } else {
            newTree.forEach((treeNode) => {
                if(treeNode.type === 'ou')
                {
                    let childNode = treeNode.children.find((n) => n.id === node.id);
                    if(childNode) {
                        updateADSettings('bpOpen', toggleOpenAction, node.id);
                    }
                }
            });
        }
    }

    const toggleFavNode = (node) => {
        console.log('toggle');
        if(node.type === 'bp') {
            props.LoadBPClick(node.id, showCompletedDocs);
        }
        var settings = null;
        try {
          settings = JSON.parse(localStorage.getItem('ADSettings'));
        } catch {}
        console.log(settings);
        if(settings.favOpen.indexOf(node.id) > -1)
        {
            updateADSettings('favOpen', 'remove', node.id);
        } else {
            updateADSettings('favOpen', 'add', node.id);
        }
    }

    const toggleFavorite = (node) => {
        console.log('toggle');
        var settings = null;
        try {
          settings = JSON.parse(localStorage.getItem('ADSettings'));
        } catch {}
        console.log(settings);
        if(settings.fav.indexOf(node.id) > -1)
        {
            updateADSettings('fav', 'remove', node.id);
        } else {
            updateADSettings('fav', 'add', node.id);
        }
    }

    const toggleShowCompletedDocs = () => {
        if (showCompletedDocs === true) {
          setShowCompletedDocs(false);
          //this.props.ChangeComplete(false);
          GetADTree(false, dispatch);
        } else {
          setShowCompletedDocs(true);
          //this.props.ChangeComplete(true);
          GetADTree(true, dispatch);
        }

      }

    return (
        <div
        className='d-flex flex-column pt-3 ps-3 text-white bg-dark'
        style={{ maxHeight: '100%', width: '320px' }}
        >
            <Link
                to='/BetaActiveDocuments'
                className='d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none'
            >
                <span className='fs-4'>
                    <i
                    style={{ color: '#E2D45B' }}
                    className='fa-solid fa-cubes'
                    />
                    {'   '}
                    Active Documents
                </span>
            </Link>
            <div className='form-check form-check-inline mt-2'>
              <input
                id='showCompletedDocs'
                className='form-check-input me-1'
                checked={showCompletedDocs}
                onChange={(event) => toggleShowCompletedDocs(event)}
                type='checkbox'
              />
              <label className='form-check-label'>Show completed documents</label>
            </div>
            <hr/>
            {!activeDocs.isLoaded &&
                <div className='h-100 d-flex flex-column align-items-center justify-content-center' style={{fontSize: '22pt'}}>
                    <div style={{color: '#8DF5F5', marginBottom: '12px'}}><i className='fa-regular fa-circle-notch fa-spin fa-2xl'  /></div>
                    <div style={{color: '#8DF5F5', fontSize: '18pt', fontFamily: 'Tilt Neon, "Courier New", monospace'}}>Loading Documents</div>
                </div>
            }
            {activeDocs.isLoaded &&
                <div
                    className='coolScroll pe-1'
                    style={{ maxHeight: `${viewHeight - 176}px`, overflow: 'auto' }}
                >
                    <ul className='list-group active-documents'>
                        <li className='list-group-item d-flex justify-content-between aligh-items-start'>
                        <div className='me-auto'>
                            <i
                            style={{ color: '#EAE83A' }}
                            className='fa-solid fa-star'
                            />{' '}
                            <strong>Favorites</strong>
                        </div>
                        </li>
            <div className='ms-3'>
              {favTrees.map((node) => (
                <React.Fragment key={node.id}>
                  <li className='list-group-item d-flex justify-content-between aligh-items-start'>
                    <div className='me-auto doc-tree-content'>
                      <span onClick={() => toggleFavNode(node)}>
                        {node.isOpen && (
                          <i className='fa-solid fa-caret-down' />
                        )}
                        {!node.isOpen && (
                          <i className='fa-solid fa-caret-right' />
                        )}{' '}
                        <span
                          style={{
                            cursor: 'pointer',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {node.name}
                        </span>{' '}
                      </span>
                    </div>
                    <span
                      className={`badge ${
                        node.count > 0 ? 'bg-success' : 'bg-secondary'
                      } rounded-pill`}
                      style={{ height: '22px' }}
                    >
                      {' '}
                      {node.count}
                    </span>
                  </li>
                  {node.isOpen && (
                    <div className='ms-3'>
                      <ul className='list-group active-documents'>
                        {node.children.map((step) => (
                          <li
                            key={step.id}
                            className='ad-navItem d-flex justify-content-between aligh-items-start'
                            onClick={(s) =>
                              props.LoadStepClick(step.id, node.id, showCompletedDocs)
                            }
                          >
                            <div
                              className='me-auto'
                              style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {step.stepType === 'User' && (
                                <span>
                                  <i className='fa-solid fa-user' />{' '}
                                  {step.name}
                                </span>
                              )}
                              {step.stepType !== 'User' && (
                                <span style={{ color: '#C1C1C1' }}>
                                  <i className='fa-solid fa-cog' />{' '}
                                  {step.name}
                                </span>
                              )}
                            </div>
                            {step.count > 0 && (
                              <span
                                className={`badge ${
                                  step.count > 0 ? 'bg-success' : 'bg-secondary'
                                } rounded-pill`}
                                style={{ height: '22px' }}
                              >
                                {step.count}
                              </span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
            <hr />
            <li className='ad-navItem-header d-flex justify-content-between aligh-items-start'>
              <div className='me-auto'>
                <i className='fa-solid fa-cubes' />{' '}
                <strong>All Documents</strong>{' '}
                {!refreshing && (
                  <span onClick={() => { setRefreshing(true); GetADTree(showCompletedDocs, dispatch); }}>
                    <i className='redo-icon fa-solid fa-redo' />
                  </span>
                )}
                {refreshing && (
                  <span>
                    <i className='fas fa-spinner fa-pulse' />
                  </span>
                )}
              </div>
            </li>
            {adTrees.map((node) => (
              <React.Fragment key={node.id + 100}>
                {node.type === 'ou' && (
                  <React.Fragment key={node.id}>
                    <li className='list-group-item d-flex justify-content-between aligh-items-start'>
                      <div
                        className='me-auto'
                        onClick={() => toggleNode(node)}
                      >
                        {node.isOpen && (
                          <i className='fa-solid fa-caret-down' />
                        )}
                        {!node.isOpen && (
                          <i className='fa-solid fa-caret-right' />
                        )}{' '}
                        <i
                          className='orgUnit-icon fa-solid fa-folder'
                        />{' '}
                        {node.name}
                      </div>
                      <span
                        className={`badge ${
                          node.count > 0 ? 'bg-success' : 'bg-secondary'
                        } rounded-pill`}
                        style={{ height: '22px' }}
                      >
                        {node.count}
                      </span>
                    </li>
                    {node.isOpen && (
                      <div className='ms-3'>
                        {node.children.map((child) => (
                          <React.Fragment key={child.id}>
                            <li className='list-group-item d-flex justify-content-between aligh-items-start'>
                              <div className='me-auto'>
                                <span onClick={() => toggleNode(child)}>
                                  {child.isOpen && (
                                    <i
                                      className='fa-solid fa-caret-down'
                                      style={{ cursor: 'pointer' }}
                                    />
                                  )}
                                  {!child.isOpen && (
                                    <i
                                      className='fa-solid fa-caret-right'
                                      style={{ cursor: 'pointer' }}
                                    />
                                  )}{' '}
                                  <span
                                    style={{
                                      cursor: 'pointer',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {child.name}
                                    <i className='redo-icon fa-solid fa-redo ms-2' />
                                  </span>
                                </span>
                              </div>
                              <span style={{ whiteSpace: 'nowrap' }}>
                                {!child.isFav && (
                                  <i
                                    onClick={() => toggleFavorite(child)}
                                    style={{ color: '#9C9C9C' }}
                                    className='fa-regular fa-star'
                                  />
                                )}
                                {child.isFav && (
                                  <i
                                    style={{ color: '#EAE83A' }}
                                    onClick={() => toggleFavorite(child)}
                                    className='fa-solid fa-star'
                                  />
                                )}{' '}
                                <span
                                  className={`badge ${
                                    child.count > 0
                                      ? 'bg-success'
                                      : 'bg-secondary'
                                  } rounded-pill`}
                                  style={{ height: '22px' }}
                                >
                                  {child.count}
                                </span>
                              </span>
                            </li>
                            {child.isOpen && (
                              <div className='ms-3'>
                                <ul className='list-group active-documents'>
                                  {child.children.map((step) => (
                                    <li
                                      key={step.id}
                                      className='ad-navItem d-flex justify-content-between aligh-items-start'
                                      onClick={(s) =>
                                        props.LoadStepClick(
                                          step.id,
                                          child.id,
                                          showCompletedDocs
                                        )
                                      }
                                    >
                                      <div
                                        className='me-auto'
                                        style={{
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {step.stepType === 'User' && (
                                          <span>
                                            <i
                                              className='fa-solid fa-user'
                                            />{' '}
                                            {step.name}
                                          </span>
                                        )}
                                        {step.stepType !== 'User' && (
                                          <span style={{ color: '#C1C1C1' }}>
                                            <i
                                              className='fa-solid fa-cog'
                                            />{' '}
                                            {step.name}
                                          </span>
                                        )}
                                      </div>
                                      {step.count > 0 && (
                                        <span
                                          className={`badge ${
                                            step.count > 0
                                              ? 'bg-success'
                                              : 'bg-secondary'
                                          } rounded-pill`}
                                          style={{ height: '22px' }}
                                        >
                                          {step.count}
                                        </span>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                  </React.Fragment>
                )}

                {node.type === 'bp' && (
                  <React.Fragment key={node.id}>
                    <li className='list-group-item d-flex justify-content-between aligh-items-start'>
                      <div className='me-auto'>
                        <span onClick={() => toggleNode(node)}>
                          {node.isOpen && (
                            <i
                              className='fa-solid fa-caret-down'
                              style={{ cursor: 'pointer' }}
                            />
                          )}
                          {!node.isOpen && (
                            <i
                              className='fa-solid fa-caret-right'
                              style={{ cursor: 'pointer' }}
                            />
                          )}{' '}
                          <span
                            style={{
                              cursor: 'pointer',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {node.name}
                          </span>
                        </span>
                      </div>
                      <span>
                        {' '}
                        {!node.isFav && (
                          <i
                            onClick={() => toggleFavorite(node)}
                            style={{ color: '#9C9C9C' }}
                            className='fa-regular fa-star'
                          />
                        )}
                        {node.isFav && (
                          <i
                            style={{ color: '#EAE83A' }}
                            onClick={() => toggleFavorite(node)}
                            className='fa-solid fa-star'
                          />
                        )}{' '}
                        <span
                          className={`badge ${
                            node.count > 0 ? 'bg-success' : 'bg-secondary'
                          } rounded-pill`}
                          style={{ height: '22px' }}
                        >
                          {node.count}
                        </span>
                      </span>
                    </li>
                    {node.isOpen && (
                      <div className='ms-3'>
                        <ul className='list-group active-documents'>
                          {node.children.map((step) => (
                            <li
                              key={step.id}
                              className='ad-navItem d-flex justify-content-between aligh-items-start'
                              onClick={() =>
                                props.LoadStepClick(step.id, node.id, showCompletedDocs)
                              }
                            >
                              <div
                                className='me-auto'
                                style={{ overflow: 'hidden' }}
                              >
                                {step.stepType === 'User' && (
                                  <span>
                                    <i className='fa-solid fa-user' />{' '}
                                    {step.name}
                                  </span>
                                )}
                                {step.stepType !== 'User' && (
                                  <span style={{ color: '#C1C1C1' }}>
                                    <i className='fa-solid fa-cog' />{' '}
                                    {step.name}
                                  </span>
                                )}
                              </div>
                              {step.count > 0 && (
                                <span
                                  className={`badge ${
                                    step.count > 0
                                      ? 'bg-success'
                                      : 'bg-secondary'
                                  } rounded-pill`}
                                  style={{ height: '22px' }}
                                >
                                  {step.count}
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            ))}
          </ul>
                </div>

            }
        </div>

    )
}

export default ActiveDocumentSidebar;